import React, { type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import AkToggle from '@atlaskit/toggle';
import { token } from '@atlaskit/tokens';

type Props = {
	isDisabled: boolean;
	initialValue: boolean;
	headingTranslated: string;
	descriptionTranslated: string;
	testId?: string;
	onChange: (event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
};

export const Toggle = ({
	initialValue,
	headingTranslated,
	descriptionTranslated,
	onChange,
	testId,
	isDisabled,
}: Props) => (
	<WarningCategoryContainer>
		<div>
			<Heading size="xsmall">{headingTranslated}</Heading>
			<Description>{descriptionTranslated}</Description>
		</div>
		<Box xcss={toggleContainerStyles}>
			<AkToggle
				testId={testId}
				defaultChecked={initialValue}
				onChange={onChange}
				isDisabled={isDisabled}
			/>
		</Box>
	</WarningCategoryContainer>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WarningCategoryContainer = styled.div({
	display: 'flex',
	width: '100%',
	justifyContent: 'space-between',
	marginTop: token('space.200'),
});

const toggleContainerStyles = xcss({
	paddingLeft: 'space.200',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.p({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: `${token('color.text')}`,
});
